export default {
  back: {
    en: 'Back',
  },
}
